/**
 * UM message thread entry point.
 *
 * TEMP: reuses CDI/ARC+ MessageBox UI + endpoints.
 * Replace when UM has its own conversation UI.
 */
import MessageBox from "../../Shared/MessageBox";

const UmMessageDetails = MessageBox;

export default UmMessageDetails;
